module.exports = __webpack_public_path__ + "media/assets/images/flags/tk-44c5967da525d9e4a773797168cac51c.svg";